module.exports = __webpack_public_path__ + "static/img/CYtu5@2x.71333d98.png";